q<template>
  <div class="mainCon">
    <div class="scene-Header">
      <div class="mainDivWidth flexDiv">
        <p class="sceneTitle">H5支付对接说明</p>
        <div class="bussinbtn" @click="goBusiness()">立即对接</div>
      </div>
    </div>
    <div class="box-shadow">
      <div class="mainDivWidth flexDiv anchorNavList" id="anchorNavList">
        <p v-for="(nl,index) in navList" :key="index" :class=" anchorId == index ? 'nowAnchor' : '' " @click="changeanchorId(index, nl.id)">
          {{nl.text}}
        </p>
      </div>
    </div>
    <section class="mainFun" id="mainFun">
      <div class="mainDivWidth flexDiv feaTure">
        <div class="introduceTextImg">
          <img
            src="static/img/docdescription/mainpic.png"
            class="introduceImg"
          />
          <p>H5支付对接说明</p>
        </div>
        <div class="first-introduceText">
          <div class="introduceText-Title flexDiv">
            <p class="titleBg">主要功能</p>
            <p class="subheading">CENTRAL FUNCTION</p>
          </div>
          <div class="cer-FunCon">
            <p>
              佰付美为满足有资质的大型在线商店对方便快捷的网上支付的诉求，专门设计的商户网站内支付模式，持卡人无须跳转第三方网关便可便捷完成支付。本产品可广泛应用于多种互联网支付场景，如网上购物、票务预订、网上订购旅游服务及公用事业缴费等实物配送类、可追溯类低风险商户。
            </p>
          </div>
        </div>
      </div>
    </section>
    <section id="payFor" class="payforCont">
      <div class="mainDivWidth">
        <h3 class="sectionTitle whiteText">支付流程</h3>
        <div class="payfortxt flexDiv">
          <div class="payforLeft" >
            <div class="forLeftcont">
              <img src="static/img/docdescription/payforion/payforion01.png" alt="">
              <p>用户</p>
            </div>
            <span>|</span>
            <div class="forLeftcont">
              <img src="static/img/docdescription/payforion/payforion02.png" alt="">
              <p>接入方</p>
            </div>
            <span>|</span>
            <div class="forLeftcont">
              <img src="static/img/docdescription/payforion/payforion03.png" alt="">
              <p>佰付美营销平台</p>
            </div>
          </div>
          <div class="payforRight">
            <p><span>1</span>用户发起H5支付，并进行付款。</p>
            <p><span>2</span>接入方组织交易报文通过浏览器发送至佰付美支付平台。</p>
            <p><span>3</span>用户选择支付方式，输入相关交易信息。</p>
            <p><span>4</span>前台交易结束，佰付美营销平台返回消息给接入方。</p>
            <p><span>5</span>后台交易结束，佰付美营销平台返回消息给接入方。</p>
          </div>
        </div>
      </div>
    </section>
    <section id="sellingPoint">
      <div class="mainDivWidth">
        <h3 class="sectionTitle">接入优势</h3>
        <div class="advantage flexDiv">
          <div class="advantCont" v-for="(spl, index) in sellingPointList" :key="index">
            <img :src="spl.pic" alt="">
            <p v-text="spl.title"></p>
          </div>
        </div>
      </div>
    </section>
    <section class="AccessMethod" id="AccessMethod">
      <h3 class="sectionTitle whiteText">接入方法</h3>
      <div class="flexDiv mainDivWidth methCont">
        <p class="pointer hoverBlueText">接入方申请接入参数，并提供签名RSA公钥</p>
        <img src="static/img/docdescription/godown.png" alt="">
        <p class="pointer hoverBlueText">获取H5支付对接文档，根据文档对接对接H5支付方式</p>
        <img src="static/img/docdescription/godown.png" alt="">
        <p class="pointer hoverBlueText">线上测试支付</p>
        <img src="static/img/docdescription/godown.png" alt="">
        <p class="pointer hoverBlueText">测试通过后投入使用</p>
      </div>
    </section>
    <section >
      <div class="mainDivWidth">
        <h3 class="sectionTitle pointer hoverBlueText">已接入支付</h3>
        <div class="flexDiv accessPay ">
          <div class="pointer hoverBlueText accesCont">
            <div class="circleradius">
              <img src="static/img/docdescription/iconpic/icon01.png">
            </div>
            <p class="accpaytext">微信支付</p>
          </div>
          <div class="pointer hoverBlueText accesCont">
            <div class="circleradius">
              <img src="static/img/docdescription/iconpic/icon02.png">
            </div>
            <p class="accpaytext">支付宝支付</p>
          </div>
          <div class="pointer hoverBlueText accesCont">
            <div class="circleradius">
              <img src="static/img/docdescription/iconpic/icon03.png">
            </div>
            <p class="accpaytext">银联支付</p>
          </div>
          <div class="pointer hoverBlueText accesCont">
            <div class="circleradius">
              <img src="static/img/docdescription/iconpic/icon04.png">
            </div>
            <p class="accpaytext">云闪付支付</p>
          </div>
          <div class="pointer hoverBlueText accesCont">
              <div class="circleradius">
                <img src="static/img/docdescription/iconpic/icon05.png">
              </div>
              <p class="accpaytext">各大银行支付</p>
            </div>
        </div>
      </div>
    </section>
    <section class="Dloadfile" id="Dloadfile">
      <h3 class="sectionTitle whiteText">下载接入</h3>
      <div class="Downloadfile">
        <div class="downCont whiteText">
          <span >下载接入H5支付对接文档，快速对接体验</span> 
          <div class="downtxt" name="downloadfile" @click="handleDownload">
            <img src="static/img/docdescription/downloadicon.png" alt="">
            <div class="downfiletxt">立即下载</div>
          </div>
          <p class="comfirtxt">该文档仅供测试参考，申请参数请联系官网微信/QQ</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'dockH5pay',
  data:function(){
    return {
      anchorId: 0,
      navList: [
        {text: '主要功能', id: 'mainFun'},
        {text: '支付流程', id: 'payFor'},
        {text: '接入优势', id: 'sellingPoint'},
        {text: '接入方法', id: 'AccessMethod'},
        {text: '下载接入', id: 'Dloadfile'},
      ],
      sellingPointList:[
        {title: '接入方便快捷', pic:"static/img/docdescription/icontont/iconfont01.png"},
        {title: '用户体验良好', pic:"static/img/docdescription/icontont/iconfont02.png"},
        {title: '可配置多活动', pic:"static/img/docdescription/icontont/iconfont03.png"},
        {title: '可以线上更新',pic:"static/img/docdescription/icontont/iconfont04.png"},
        {title: '立即投入使用',pic:"static/img/docdescription/icontont/iconfont05.png"}
      ],  
      payforList:[
        {
          title:"用户",
          pic:"static/img/docdescription/payforion.png"
        },{
          title:"接入方",
          pic:"static/img/docdescription/payforion.png"
        },
        {
          title:"佰付美营销平台",
          pic:"static/img/docdescription/payforion.png"
        }
      ]
    }
  },
  mounted() {
  },
  methods:{
    // 立即下载
    handleDownload(){
      let a = document.createElement('a')
      a.href ="https://cdn.epaynfc.com/Activities/2006June/other/downloadfile/佰付美第三方H5支付接入说明.pdf"
      a.click();
    },
    goBusiness(){
      this.$router.push({"path": "/cooperate"})
    },
    changeanchorId(num, id){
      this.anchorId = num;
      $('html, body').animate({scrollTop: $('#'+id).offset().top }, 1000);
      return false;// 返回false可以避免在原链接后加上#  
    },
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/descriptionClass/docStyle";
  @import "../../assets/css/descriptionClass/H5paysty";
</style>



// WEBPACK FOOTER //
// src/pages/dockingConPage/document1-H5Pay.vue